import React from 'react';
import { useSelector } from 'react-redux';
import _ from 'lodash';
import ProposalSection from './ProposalSection';

/**
 * ProposalConfigSections Component
 * Dynamically renders all enabled sections from proposalConfig
 * Section order matches the expected proposal flow
 */
const ProposalConfigSections = () => {
  const proposalConfig = useSelector((state) => _.get(state.proposalData, 'data.proposalConfig', {}));

  if (!proposalConfig || _.isEmpty(proposalConfig)) {
    return null;
  }

  return (
    <>
      <ProposalSection sectionId="interfaceAndLed" sectionData={proposalConfig.interfaceAndLed} />

      <ProposalSection sectionId="backdropSection" sectionData={proposalConfig.backdropSection} />

      <ProposalSection sectionId="templatesOverlays" sectionData={proposalConfig.templatesOverlays} />

      <ProposalSection sectionId="photos" sectionData={proposalConfig.modes?.photos} />

      <ProposalSection sectionId="boomerangs" sectionData={proposalConfig.modes?.boomerangs} />

      <ProposalSection sectionId="videos" sectionData={proposalConfig.modes?.videos} />

      <ProposalSection sectionId="gifs" sectionData={proposalConfig.modes?.gifs} />

      <ProposalSection sectionId="poseTips" sectionData={proposalConfig.effects?.poseTips} />

      <ProposalSection sectionId="masks" sectionData={proposalConfig.effects?.masks} />

      <ProposalSection sectionId="glam" sectionData={proposalConfig.effects?.glam} />

      <ProposalSection sectionId="greenScreen" sectionData={proposalConfig.effects?.greenScreen} />

      <ProposalSection sectionId="sharing-general" sectionData={proposalConfig.sharing?.general} />

      <ProposalSection sectionId="email" sectionData={proposalConfig.sharing?.email} />

      <ProposalSection sectionId="sms" sectionData={proposalConfig.sharing?.sms} />

      <ProposalSection sectionId="liveGallery" sectionData={proposalConfig.liveGallery} />

      <ProposalSection sectionId="printing" sectionData={proposalConfig.sharing?.printing} />

      <ProposalSection sectionId="pricing" sectionData={proposalConfig.pricing} />

      <ProposalSection sectionId="customSection" sectionData={proposalConfig.customSection} />

      <ProposalSection sectionId="callToAction" sectionData={proposalConfig.callToAction} />
    </>
  );
};

export default ProposalConfigSections;
